export class PaginationUtils {
  static getVisiblePages(
    currentPage: number,
    totalPages: number,
    maxVisible: number = 3
  ): number[] {
    const start = Math.max(2, currentPage - Math.floor(maxVisible / 2))
    const end = Math.min(totalPages, start + maxVisible - 1)
    const adjustedStart = Math.max(2, end - maxVisible + 1)
    const pages = Array.from({length: end - adjustedStart + 1}, (_, i) => adjustedStart + i)
    return [1, ...pages]
  }

  static getPaginationRange(currentPage: number, pageSize: number, totalItems: number) {
    const start = (currentPage - 1) * pageSize + 1
    const end = Math.min(currentPage * pageSize, totalItems)
    return {start, end}
  }
}
export const cleanVariables = (vars: any) => {
  return Object.fromEntries(
    Object.entries(vars).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
  )
}